import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { participationMessages } from 'src/app/common-class/survey-messages';
import {} from 'events';
import { ParticipationDataService } from 'src/app/_services/participation-data.service';
import { CommonSetting } from 'src/app/common-class/survey';

@Component({
  selector: 'app-survey-messages',
  templateUrl: './survey-messages.component.html',
  styleUrls: ['./survey-messages.component.css'],
})
export class SurveyMessagesComponent implements OnInit {
  @Input() participation_Messages: participationMessages;
  @Input() participation_Message_Type: number;
  @Input() isSurveyExpired: boolean;
  @Input() isSubscriptionModel: boolean;
  @Input() isMobile: boolean;
  @Input() isTablet: boolean;
  @Input() PoweredByText: string;
  @Input() isPreview: boolean;
  @Input() isAssessment: boolean;
  @Input() ProductName: string;
  @Input() SupportEmail: string;
  @Input() isPowredByClient: boolean;
  @Input() SurveyLogoImageUrl: string;
  @Input() SurveyLogoAlign: number;
  @Input() SurveyURL: string;
  @Input() Title: string;
  @Output() partialResponceHandling: EventEmitter<any> = new EventEmitter();
  @Output() EditResponceHandling: EventEmitter<any> = new EventEmitter();
  constructor(
    private service: ParticipationDataService,
    private commonSetting: CommonSetting,
  ) {}

  isPartialAccessHide: boolean;
  isPartialAccessDoneHide: boolean;
  isPartialMessage3Visible: boolean;
  email_id: string;
  unique_url: string;
  isRTL: boolean;
  surveyType: string;
  isEmbedMobile: boolean;
  isEmailValid: boolean = false;
  path: string = '';
  isCookieEnable: boolean;
  cookieSupportLinks: any;
  isIE: boolean = false;
  isSafari: boolean = false;
  islinkemail: boolean = false;
  isTechCheck: boolean = false;

  ngOnInit() {
    this.isPartialAccessHide = true;
    this.isPartialAccessDoneHide = false;
    this.isPartialMessage3Visible = true;
    if (
      this.participation_Messages.partial_and_quota_message != null &&
      this.participation_Messages.partial_and_quota_message != undefined &&
      this.participation_Messages.partial_and_quota_message.unique_url != null &&
      this.participation_Messages.partial_and_quota_message.unique_url != undefined
    ) {
      this.unique_url = this.participation_Messages.partial_and_quota_message.unique_url.replace(
        '/k',
        '/k1',
      );
    }
    this.isRTL = this.service.isRTL;
    this.surveyType = this.isAssessment ? 'Assessment' : 'Survey';
    const partialMessage3 =
      this.participation_Messages?.partial_and_quota_message?.partial_message3;
    this.isPartialMessage3Visible = this.isNonEmptyHtml(partialMessage3);

    if (this.commonSetting.isEmbedMobile == 1) {
      this.isEmbedMobile = true;
    }
    this.path = '../survey/' + this.service.getImageFolder();

    if (this.participation_Message_Type == 4) {
      let browserCookieStatus = navigator.cookieEnabled;
      var msie = navigator.userAgent.indexOf('MSIE ');
      this.isSafari =
        navigator.userAgent.includes('Safari') &&
        navigator.userAgent.includes('Apple') &&
        /iPhone|iPad|iPod|Macintosh/.test(navigator.userAgent);
      if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
        // If Internet Explorer, return version number
        this.isIE = true;
      } else {
        if (browserCookieStatus != undefined && browserCookieStatus) {
          this.isCookieEnable = true;
          this.SurveyURL = (this.SurveyURL || '').replace('&isEmbedMobile=1', '');
        } else {
          this.isCookieEnable = false;
        }
      }
      if ((this.isCookieEnable && this.isSafari) || (this.isEmbedMobile && this.isIE)) {
        this.isTechCheck = true;
      }
    }
    this.setBrowserCookieLinks();
  }

  ngAfterViewInit() {
    if (document.querySelectorAll('.mobile-wrapper').length == 0) {
      this.setMessage();
    }

    const getSurveyHeight = document.getElementById('participationBodyScrollMain')?.offsetHeight || 0;
    const surveyMsgWrapper = document.querySelector('.SurveyMsgWrapper');
    if (getSurveyHeight < 700) {
      surveyMsgWrapper?.classList.add('tabSurveyHeihgt');
    } else {
      surveyMsgWrapper?.classList.remove('tabSurveyHeihgt');
    }

    if (
      this.participation_Messages.partial_and_quota_message &&
      this.participation_Messages.partial_and_quota_message.unique_url
    ) {
      const copyWidth = document.querySelector('.url-info')?.getBoundingClientRect().width || 0;
      const sendEmailText = document.querySelector('.send-email-text') as HTMLElement;
      if (sendEmailText) {
        sendEmailText.style.width = `${copyWidth - 28}px`;
      }
    }


    setTimeout(() => {
      const accordionMessages = document.querySelectorAll('.ap_accordion_msg span');
      accordionMessages.forEach((span) => {
        span.addEventListener('click', function () {
          if (this.classList.contains('checkData')) {
            this.classList.remove('checkData');
          } else {
            document.querySelectorAll('.checkData').forEach((el) => el.classList.remove('checkData'));
            this.classList.add('checkData');
          }
        });
      });
    }, 10);

    if (this.participation_Messages.addAddNoContent) {
      const metaTag = document.createElement('meta');
      metaTag.name = 'robots';
      metaTag.content = 'noindex, nofollow, noarchive';
      document.head.appendChild(metaTag);
    }

    if (
      this.participation_Message_Type == 51 &&
      document.querySelectorAll('.SurveyMsgWrapper .ap_accordion_msg').length == 0
    ) {
      surveyMsgWrapper?.classList.add('Notaccordion_surveyMsg');
    }
  }

  BeginNewResponse(event: any) {
    this.partialResponceHandling.emit(event);
  }
  BeginNewResponseRef(event: any) {
    this.partialResponceHandling.emit(event);
  }
  BrowserContinue(event: any) {
    this.partialResponceHandling.emit(event);
  }
  LastLeftResponse(event: any) {
    this.partialResponceHandling.emit(event);
  }
  SurveyEdiited(event: any) {
    this.partialResponceHandling.emit(event);
  }

  linkemail(event: any) {
    if (this.participation_Messages.partial_and_quota_message.isQuota) {
      this.EditResponceHandling.emit(event);
    } else {
      if (this.email_id == '' || this.email_id == null) {
        alert('Please enter Email Address.');
      } else if (this.isEmailValid) {
        alert('Invalid Email Address!');
      } else {
        let arrPartiallyDone: Array<string> = [];

        arrPartiallyDone[0] = 'true';
        arrPartiallyDone[1] = this.email_id;
        arrPartiallyDone[2] = 'send';

        this.EditResponceHandling.emit(arrPartiallyDone);
        this.islinkemail = true;
      }
    }
  }

  goBackQuota(event: any) {
    if (this.isEmailValid) {
      alert('Invalid Email Address!');
    } else {
      if (this.participation_Messages.partial_and_quota_message.isQuota) {
        this.EditResponceHandling.emit(event);
      } else {
        let arrPartiallyDone: Array<string> = [];

        arrPartiallyDone[0] = 'true';
        arrPartiallyDone[1] = this.email_id;
        arrPartiallyDone[2] = 'done';

        this.EditResponceHandling.emit(arrPartiallyDone);
        this.isPartialAccessHide = false;
        this.isPartialAccessDoneHide = true;
      }
    }
  }

  setMessage() {
    const surveyMsgWrapper = document.querySelector('.SurveyMsgWrapper') as HTMLElement;
    if (surveyMsgWrapper?.classList.contains('browser-message-width')) {
      surveyMsgWrapper.style.width = '80%';
      surveyMsgWrapper.style.maxWidth = '80%';
    }
    if (this.isMobile) {
      surveyMsgWrapper.style.width = '99%';
      surveyMsgWrapper.style.maxWidth = '99%';

      if (surveyMsgWrapper.offsetHeight < window.innerHeight) {
        Object.assign(surveyMsgWrapper.style, {
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '75%',
          maxWidth: '75%',
        });
      } else {
        Object.assign(surveyMsgWrapper.style, {
          position: 'relative',
          top: '0',
          left: '0',
          transform: 'translate(0, 0)',
          width: '75%',
          maxWidth: '75%',
        });
      }
    }
  }

  emailValidation(curVal: string) {
    if (curVal == '' || curVal == null) {
      this.isEmailValid = false;
    } else {
      const regexp = new RegExp(/^([a-zA-Z0-9_\.\'\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z])+$/);
      let isValid = regexp.test(curVal);

      if (!isValid) {
        this.isEmailValid = true;
        alert('Invalid Email Address!');
      } else {
        this.isEmailValid = false;
      }
    }
  }

  setBrowserCookieLinks() {
    if (this.isMobile || this.isTablet) {
      this.cookieSupportLinks = {
        safari: 'https://support.apple.com/en-in/HT201265',
        chrome:
          'https://support.google.com/accounts/answer/61416?co=GENIE.Platform%3DAndroid&hl=en&oco=1',
        firefox: 'https://support.mozilla.org/en-US/kb/enable-or-disable-cookies-firefox-android',
        edge: 'https://answers.microsoft.com/en-us/windows/forum/apps_windows_10-msedge/edge-how-do-i-enable-cookies/275b58e3-d741-4b21-8042-3059b1902d0e',
      };
    } else {
      this.cookieSupportLinks = {
        safari: 'https://support.apple.com/en-in/guide/safari/sfri11471/mac',
        chrome:
          'https://support.google.com/accounts/answer/61416?co=GENIE.Platform%3DDesktop&hl=en&oco=1',
        firefox:
          'https://support.mozilla.org/en-US/kb/websites-say-cookies-are-blocked-unblock-them',
        edge: 'https://answers.microsoft.com/en-us/windows/forum/apps_windows_10-msedge/edge-how-do-i-enable-cookies/275b58e3-d741-4b21-8042-3059b1902d0e',
        ie: 'https://support.microsoft.com/en-in/help/17442/windows-internet-explorer-delete-manage-cookies',
      };
    }
  }

  copyToClipboard() {
    const tempInput = document.createElement('input');
    document.body.appendChild(tempInput);
    tempInput.value = this.participation_Messages?.partial_and_quota_message.unique_url1 || '';
    tempInput.select();
    document.execCommand('copy');
    document.body.removeChild(tempInput);
  }

  isNonEmptyHtml(content: string | undefined | null): boolean {
    if (!content) {
      return false;
    }
    let textOnly = content.replace(/<[^>]*>/g, '').trim();
    textOnly = textOnly.replace(/&nbsp;/g, '').trim();
    return textOnly.length > 0;
  }
}
